import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const POWER = () => {
  return (
    <CardSection id="POWER" title="POWER">
      <Paragraph>
        주어진 숫자를 지정한 지수만큼 거듭제곱한 결과를 반환합니다. Excel의
        POWER 함수와 동일한 출력을 제공합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>POWER(NUMBER, POWER)</Paragraph>
        <Ul>
          <Li>
            <b>NUMBER</b>는 거듭제곱할 밑수입니다.
          </Li>
          <Li>
            <b>POWER</b>는 밑수를 제곱할 지수, 즉 임의의 실수입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>POWER(`Column`, 2)</Paragraph>
        <Img src="computePower" />
      </ListSection>
    </CardSection>
  );
};
